import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
// import thunk from 'redux-thunk';
import { thunk } from 'redux-thunk';
import { configureStore } from '@reduxjs/toolkit'; // Recommended for Redux Toolkit usage
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/integration/react';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// google-fonts
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/700.css';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

// project import
import App from './App';
import reportWebVitals from './reportWebVitals';
import reducers from '../src/store/reducer/index'; // Adjust path to your reducers

// Redux Persist Configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['updateLanguage'] // Add reducers to be persisted
};

// Persisted Reducer
const persistedReducer = persistReducer(persistConfig, reducers);

// Redux Store Configuration
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false // Required for redux-persist
    }).concat(thunk),
  devTools: process.env.NODE_ENV !== 'production' // Enable Redux DevTools in development
});

// Persistor
const persistor = persistStore(store);

// Render the App
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {/* <HashRouter> */}
      <App />
      {/* </HashRouter> */}
    </PersistGate>
  </Provider>
);

// Measure performance (optional)
reportWebVitals();
